import type { ReactNode } from 'react';

const FieldNote = ({ note }: { note?: ReactNode }) =>
  note && (
    <span data-testid="fieldNote" className="field__note">
      {note}
    </span>
  );

export default FieldNote;
